export enum ProductStock {
    OutOfStock = -1,
    OnlyOne = 0,
    LessThanFive = 1,
    FiveOrMore = 2,
    TenOrMore = 3,
    Alot = 4
}
